/* VersionControlExplorerLmrbComponent.js */

"use strict";

const GameEditor = require("@gluenetworks/game_editor");
const Steve = require("@gluenetworks/steve_core").getInstance();
const _ = require("lodash");
const Registrations = require("../../../RegistrationNamespaces");

class VersionControlExplorerLmrbComponent extends GameEditor {
    constructor(logger, di, editorLayout, userSession) {
        super(logger, di);

        this._editorLayout = editorLayout;
        this._userSession = userSession;

        this._updateNameSpaces();

        this._activeOrgId = _.get(this._userSession, "activeOrganization.id");

        this._registerVersionControlExplorerListeners();

        this._openEditorFromUrl = false;
        this._filterFromUrl = false;
        this._emptyFilter = false;
        let superRender = this.renderer.render;

        this.renderer.render = (args) => {
            return superRender.apply(this.renderer, args).then(() => {
                this.renderer.rootElement.classList.add("version-control-explorer-lmrb");

                this.whenGameEditorStorageIsReady().then(() => {
                    let otherParams = _.get(Steve.router.getRouteDetails(), "rd", "");
                    if (otherParams.openEditor || !_.isEmpty(otherParams.selection)) {
                        this._openEditorFromUrl = {
                            open: otherParams.openEditor || false,
                            selectedIds: otherParams.selection,
                        };
                    }
                    if (!_.isEmpty(otherParams.filter)) {
                        this._filterFromUrl = true;
                    }
                    if (_.isEmpty(otherParams.filter) && !_.isUndefined(otherParams.filter)) {
                        this._emptyFilter = true;
                    }

                    this._cabinetCmpnt.selectView(Registrations.VERSION_CONTROL_EXPLORER_GRID);
                });
            });
        };
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    _updateNameSpaces(withUpdate) {
        let solutionDefinition = this._solutionManager.getActiveSolution();
        let gameEditorViews = _.get(
            solutionDefinition,
            "versionControlExplorer.viewNamespaces",
            []
        );
        let gameEditorActions = _.get(
            solutionDefinition,
            "versionControlExplorer.actionNamespaces",
            []
        );

        this.setNamespaceGlobs(gameEditorViews.concat(gameEditorActions), !withUpdate);
    }

    _registerVersionControlExplorerListeners() {
        this._solutionManager.on(
            "activeSolutionChanged",
            (this._onSolutionChanged = this._onSolutionChanged.bind(this))
        );
        this._userSession.on(
            "OrganizationChange",
            (this._onOrganizationChange = this._onOrganizationChange.bind(this))
        );
    }

    _unregisterVersionControlExplorerListeners() {
        if (this._solutionManager) {
            this._solutionManager.removeListener("activeSolutionChanged", this._onSolutionChanged);
        }
        if (this._userSession) {
            this._userSession.removeListener("OrganizationChange", this._onOrganizationChange);
        }
    }

    launchVersionControlEditor(editorState, launchOpts) {
        const {selectedId} = launchOpts;
        this.generateHash(selectedId)
            .catch((error) => this._logger.warn({error}))
            .then((tabId) => {
                launchOpts = _.assign({}, launchOpts, {
                    id: tabId,
                    selectedId,
                });
                return this._editorLayout.launchEditor(
                    editorState,
                    Registrations.VERSION_CONTROL_INSTANCE_EDITOR,
                    launchOpts
                );
            });
    }

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    shutdown() {
        let shutdowns = [];
        return Promise.all(shutdowns).then(
            () => {
                this._unregisterVersionControlExplorerListeners();
                this._editorLayout = undefined;
                this._userSession = undefined;
                this._activeOrgId = undefined;
                this._openEditorFromUrl = undefined;
                this._filterFromUrl = undefined;
                this._emptyFilter = undefined;
                return super.shutdown();
            },
            (err) => {
                this._logger.warn(
                    {error: err},
                    "VersionControlExplorerEntityLmrbComponent.shutdown() error"
                );
            }
        );
    }

    /*******************************************/
    /* START HANDLER METHODS                   */
    /*******************************************/

    _onSolutionChanged() {
        this.shutdown();
    }

    _onOrganizationChange({id}) {
        if (id !== this._activeOrgId) {
            this._activeOrgId = id;
            this.renderer.render();
        }
    }
}

module.exports = VersionControlExplorerLmrbComponent;

VersionControlExplorerLmrbComponent.$inject = [
    "$teve.logger",
    "$teve.di",
    "EditorLayout.EditorLayout",
    "$teve.userSession",
];
VersionControlExplorerLmrbComponent.$supportedQuadrants = ["bottom"];
VersionControlExplorerLmrbComponent.$defaultQuadrants = ["bottom"];
VersionControlExplorerLmrbComponent.$iconRepoName = "versioncontrol.version_explorer";
VersionControlExplorerLmrbComponent.$openedByDefault = true;
VersionControlExplorerLmrbComponent.$displayName = "Version Explorer";
